import { render, staticRenderFns } from "./HomeSanitizer.vue?vue&type=template&id=84e3753a&scoped=true&"
import script from "./HomeSanitizer.vue?vue&type=script&lang=js&"
export * from "./HomeSanitizer.vue?vue&type=script&lang=js&"
import style0 from "./HomeSanitizer.vue?vue&type=style&index=0&id=84e3753a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e3753a",
  null
  
)

export default component.exports